export default __webpack_public_path__ + "static/media/QSGRW_RW-Connected_PopUp.ef14b833.png";